<script setup lang="ts">
import SideMenu from '@/components/SideMenu.vue'
import ConfirmPopup from '@/components/popup/ConfirmPopup.vue'
import PromptPopup from '@/components/popup/PromptPopup.vue'
import AlertPopup from '@/components/popup/AlertPopup.vue'
import InfoPopup from '@/components/popup/InfoPopup.vue'

import TokenExpiredPopup from './components/popup/TokenExpiredPopup.vue'
import { onMounted, ref, watch } from 'vue'
import { useStore } from '@/core/store'
import FlashContainer from './components/flashMessages/FlashContainer.vue'
import { tokenExpirationUtil } from './utils/TokenExpirationUtil'

const publicUrl = import.meta.env.VITE_API_URL as string
let interval: any

const theme = ref(localStorage.getItem('theme') || 'light')

onMounted(() => {
  const store = useStore()
  document.body.className = theme.value

  console.log('App mounted')
  interval = setInterval(() => {
    console.log('Refreshing')
    if (store.isAuthenticated) {
      store
        .refresh()
        .then(() => console.log('Token refreshed'))
        .catch(() => {
          tokenExpirationUtil.warnTokenIsExpired()
          clearInterval(interval)
        })
    }
  }, 1000 * 60)
})

watch(theme, (newTheme) => {
  document.body.className = newTheme

  localStorage.setItem('theme', newTheme)
})
</script>

<template>
  <TokenExpiredPopup />
  <FlashContainer />
  <ConfirmPopup />
  <PromptPopup />
  <AlertPopup />
  <InfoPopup />

  <div id="appBar">
    <a :href="publicUrl">
      <img src="@/assets/img/logo/pollux.png" alt="Logo" />

      <div>
        <h2>The Synthetic Stellar</h2>
        <h2>Spectrum database Pollux</h2>
      </div>
    </a>
  </div>

  <div class="app-container">
    <SideMenu />
    <div class="router-view">
      <router-view :key="$route.fullPath" />
    </div>
  </div>

  <div class="theme-selector">
    <button type="button" @click="theme = theme === 'dark' ? 'light' : 'dark'">
      <span v-if="theme === 'dark'" class="material-symbols-outlined">dark_mode</span>
      <span v-else class="material-symbols-outlined">light_mode</span>
    </button>
  </div>
</template>

<style scoped lang="scss">
.flashes {
  z-index: 1000;
  position: fixed;
}

.theme-selector {
  position: fixed;
  top: 104px;
  right: 10px;

  button {
    background-color: transparent;
    color: var(--theme-color);
    border: none;
    border-radius: 50%;
    padding: 10px;
    cursor: pointer;
  }
}

#appBar {
  background-image: url('@/assets/img/header/banner.png');
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 94px;
  z-index: 999;

  border-bottom: 4px solid #2253a0;

  display: flex;
  align-items: center;

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #eee;
    gap: 10px;
    font-weight: lighter;
    text-transform: uppercase;
    font-size: 1rem;

    h2 {
      color: #eee;
    }

    img {
      height: 48px;
      margin-left: 30px;
    }
  }
}

.app-container {
  margin-top: 94px;
  display: flex;
  gap: 0;
  position: relative;
  min-height: 100%;
  height: 100%;
}

.router-view {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
}
</style>
